import { ColumnDescriptionDc } from "@evergis/api";
import { TableAttribute } from "../../components/Dialogs/EditResource/components/Table/TableAttributeItem";

export type ColumnsChanged = {
  columnsAdd: ColumnDescriptionDc[];
  columnsDelete: string[];
};

const EMPTY_COLUMNS_UPDATE: ColumnsChanged = {
  columnsAdd: [],
  columnsDelete: [],
};

export function getColumnsUpdate(attributes: TableAttribute[], tableColumns: ColumnDescriptionDc[]): ColumnsChanged {
  if (!attributes || !tableColumns) {
    return EMPTY_COLUMNS_UPDATE;
  }

  const columnsAdd = attributes.filter(({ editable }) => editable);
  const attributeNames = attributes.map(({ name }) => name);
  const columnsDelete = tableColumns.map(({ name }) => name).filter(columnName => !attributeNames.includes(columnName));

  return {
    columnsAdd,
    columnsDelete,
  };
}
